export const avatarOptions = [
  { id: 'blue', glyph: 'A', label: 'Inisial biru' },
  { id: 'fox', glyph: '🦊', label: 'Rubah' },
  { id: 'panda', glyph: '🐼', label: 'Panda' },
  { id: 'cat', glyph: '🐱', label: 'Kucing' },
  { id: 'dog', glyph: '🐶', label: 'Anjing' },
  { id: 'rabbit', glyph: '🐰', label: 'Kelinci' },
  { id: 'owl', glyph: '🦉', label: 'Burung hantu' },
  { id: 'koala', glyph: '🐨', label: 'Koala' },
] as const

export function ProfileAvatar({ avatarId, letter, large = false }: { avatarId?: string | null; letter: string; large?: boolean }) {
  const option = avatarOptions.find((item) => item.id === avatarId) ?? avatarOptions[0]
  return <span className={`profile-avatar${large ? ' profile-avatar--large' : ''} profile-avatar--${option.id}`} aria-hidden="true">{option.id === 'blue' ? letter : option.glyph}</span>
}
